import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import Select from 'components/Select/index'
import TreeSelect from 'components/TreeSelect'
import Toggle from 'components/UIComponents/Toggle'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import GroupPeopleIcon from 'components/icons/GroupPeopleIcon'
import {
  AddClgDiv,
  RatingFlex,
  ShortListCanDiv,
  ShortListDiv,
  ShortlistDiv,
  ShortlistFlex,
  ToggleDiv,
} from 'modules/Roles/ViewRole/DriveDrawers/Style/style'
import React, { useEffect, useState } from 'react'
import { COLORS } from 'theme'

import { RedText } from 'components/UIComponents/FormStyles'

const ApplyFilter = ({
  applyFilter,
  setApplyFilter,
  studentRating,
  setStudentRating,
  minScore,
  setMinScore,
  degreeDepartment,
  setDegreeDepartment,
  count,
  selectedInstitute,
  errors,
  selectedInstituteOfVirtualDrive,
  rolesDegreeList,
  isDisplay = true,
}) => {
  const [ratingOption, setRatingOption] = useState([])
  useEffect(() => {
    const ratings = []
    for (let i = 0.5; i <= 4.5; i += 0.5) {
      ratings.push({
        name: (
          <RatingFlex alignCenter>
            <div>{`Above ${i.toFixed(1)}`}</div>
            <GreenStarIcon />
          </RatingFlex>
        ),
        value: `${i.toFixed(1)}`,
      })
    }
    setRatingOption(ratings)
  }, [])

  const percentageOption = [
    {
      name: 'Above 50% ',
      value: 50,
    },
    {
      name: 'Above 55% ',
      value: 55,
    },
    {
      name: 'Above  60%',
      value: 60,
    },
    {
      name: 'Above 65% ',
      value: 65,
    },
    {
      name: 'Above 70% ',
      value: 70,
    },
    {
      name: 'Above  75%',
      value: 75,
    },
    {
      name: 'Above 80% ',
      value: 80,
    },
    {
      name: 'Above 85% ',
      value: 85,
    },
    {
      name: 'Above 90% ',
      value: 90,
    },
    {
      name: 'Above 95%',
      value: 95,
    },
  ]

  useEffect(() => {}, [applyFilter, studentRating, minScore, degreeDepartment])

  const onDegreeChangeHandler = (keys, info) => {
    setDegreeDepartment(keys)
  }
  const filterOnClick = e => {
    setApplyFilter(false)
    setStudentRating('')
    setMinScore('')
    setDegreeDepartment('')
  }

  return (
    <>
      <Flex column>
        <ShortListDiv>Shortlist Candidates</ShortListDiv>
        <ShortListCanDiv>
          Select all the candidates or apply filters to shortlist candidates
        </ShortListCanDiv>
      </Flex>
      <ToggleDiv>
        <Toggle
          left="All Applied Candidates"
          right="Apply Filter"
          initialValue={applyFilter ? 'right' : 'left'}
          onClick={e => (e === true ? setApplyFilter(e) : filterOnClick())}
        />
      </ToggleDiv>

      <RedText>{errors?.filterError}</RedText>

      {applyFilter && (
        <div>
          <AddClgDiv>
            <Select
              allowClear
              label="Ratings"
              placeholder="Select"
              OptionData={ratingOption}
              valueParam={'value'}
              value={studentRating}
              onChange={value => setStudentRating(value)}
            />
          </AddClgDiv>
          <AddClgDiv>
            <Select
              allowClear
              label="Percentage"
              placeholder="Select"
              OptionData={percentageOption}
              valueParam={'value'}
              value={minScore}
              onChange={value => setMinScore(value)}
            />
          </AddClgDiv>
          <AddClgDiv>
            <Label>Degree and department</Label>
            <TreeSelect
              id="previewDriveFilter"
              showSearch
              treeData={rolesDegreeList}
              treeCheckable={true}
              placeholder="Select"
              maxTagCount={5}
              onChange={onDegreeChangeHandler}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              height="auto"
            />
          </AddClgDiv>
        </div>
      )}
      {isDisplay && (
        <>
          {Object.keys(selectedInstitute)?.length ? (
            <AddClgDiv>
              <ShortlistFlex
                background={count > 0 ? '#eff8f4' : COLORS.RED_T_92}
              >
                <GroupPeopleIcon color={count > 0 ? '#5DB594' : 'red'} />
                {count ? (
                  <ShortlistDiv>
                    {count} {count == '1' ? 'candidate' : 'candidates'}{' '}
                    shortlisted for this drive.
                  </ShortlistDiv>
                ) : (
                  <ShortlistDiv>
                    No candidates shortlisted for this drive.
                  </ShortlistDiv>
                )}
              </ShortlistFlex>
            </AddClgDiv>
          ) : selectedInstituteOfVirtualDrive?.length > 0 ? (
            <>
              {' '}
              <AddClgDiv>
                <ShortlistFlex
                  background={count > 0 ? '#eff8f4' : COLORS.RED_T_92}
                >
                  <GroupPeopleIcon color={count > 0 ? '#5DB594' : 'red'} />
                  {count ? (
                    <ShortlistDiv>
                      {count} {count == '1' ? 'candidate' : 'candidates'}{' '}
                      shortlisted for this drive.
                    </ShortlistDiv>
                  ) : (
                    <ShortlistDiv>
                      No candidates shortlisted for this drive.
                    </ShortlistDiv>
                  )}
                </ShortlistFlex>
              </AddClgDiv>
            </>
          ) : null}
        </>
      )}
    </>
  )
}

export default ApplyFilter
